import { renderedSessionsIdsUpdated } from '../state';
import type { SessionId } from '../../domain/Session';

type Args = {
    renderedSessionsIds: SessionId[];
};

export const UpdateRenderedSessionsIdsCommand = ({ renderedSessionsIds }: Args) =>
    renderedSessionsIdsUpdated(renderedSessionsIds);
